import { h, Component } from "preact";
import { getApiPath, localPath } from "../../path";

import style from "./style";

import SearchTypes from "../../components/search-types";
import TitleList from "../../components/title-list";

export default class Home extends Component {
  // Used for setting selections in url
  dbKey = "db";
  typeKey = "type";

  state = {
    dbLoaded: false,
    selectedDb: 0,
    selectedType: null,
    filterByLetter: false,
    databases: [],
  };

  handleSelectDb = (event) => {
    this.setState((previousState) => {
      return {
        ...previousState,
        selectedDb: event.target.value,
        selectedType: null,
      };
    });
  };

  handleButtonClick = (id, event) => {
    this.setState((previousState) => {
      return { ...previousState, selectedType: id, filterByLetter: false };
    });
    this.setSelectedInUrl(this.state.selectedDb, id);
  };

  handleLoadingDatabases = (data) => {
    this.setState((previousState) => ({
      ...previousState,
      databases: data.map((dbItem) => ({
        label: dbItem.label,
        searchTypes: dbItem.subitems,
      })),
      dbLoaded: true,
    }));
  };

  translateTypeIdToTypeString(id) {
    let typeLabel = false;
    const selectedDb = this.state.databases[this.state.selectedDb];
    if (selectedDb && selectedDb.searchTypes) {
      const selectedTypes = selectedDb.searchTypes.filter(
        (type) => type.id === id
      );
      if (selectedTypes.length === 1) {
        typeLabel = selectedTypes[0].label;
      }
    }

    return typeLabel;
  }

  /**
   *
   * @param {String} searchType The id of the selected search type, selected by clicking the button
   */
  getDisplayList(searchType) {
    const typeLabel = searchType;
    const listMap = {
      //romans
      5: "author",
      9: "author",
      3: "quote",
      38: "genre",
      //ziekte
      1: "author",
      //film
      17: "author",
      14: "titel",
      39: "genre",
      //art
      20: "author",
      19: "artist",
      //about
      36: "titel",
      37: "author",
      35: "work",
      //poetry
      29: "poet",
      31: "poem",
    };

    if (typeLabel && Object.prototype.hasOwnProperty.call(listMap, typeLabel)) {
      return listMap[typeLabel];
    }

    return false;
  }

  /**
   * Get the type of list we want to display. Is used by ListSwitch
   * @param {id} searchType The searchtype that was selected by clicking the search type button or from the url
   */
  getDisplayType(searchTypeId) {
    const searchType = searchTypeId;
    const typeMap = {
      //romans
      5: "name",
      9: "keyword",
      3: "keyword",
      38: "genre",
      //ziekte
      1: "keyword",
      //film
      17: "keyword",
      14: "titel",
      39: "genre",
      //art
      20: "keyword",
      19: "name",
      //about
      36: "keyword",
      37: "name",
      35: "work",
      //poetry
      29: "poet",
      31: "keyword",
    };

    if (Object.prototype.hasOwnProperty.call(typeMap, searchType)) {
      return typeMap[searchType];
    }

    return false;
  }

  getDatabase(dbIndex) {
    return this.state.databases[dbIndex].label;
  }

  /**
   * Sets a query string in the url that can be used to get the state of a search
   * Used when navigating back from a detail screen
   * @param {number} selectedDb The index of the selected database from the dropdown
   * @param {string} selectedType The text of the selected search type
   */
  setSelectedInUrl(selectedDb, selectedType) {
    // Encode and decode because there can be special chars in the string
    const db = encodeURIComponent(selectedDb);
    const type = encodeURIComponent(selectedType);
    history.replaceState(
      null,
      null,
      `${localPath(this.props.locale, "")}?${this.dbKey}=${db}&${
        this.typeKey
      }=${type}`
    );
  }

  /**
   * Parses the querystring and tries to get the selected db and searchtype
   * @param {Object{selectedDb: number; selectedType: string;}} searchParams
   */
  getSelectedFromUrl(searchParams) {
    // let selectedDb, selectedType;
    let returnObject = {
      selectedDb: null,
      selectedType: "",
    };

    const paramArray = searchParams.split("&");

    if (paramArray.length > 1) {
      const paramObject = paramArray.reduce((prev, curr) => {
        const resArray = curr.split("=");
        return {
          ...prev,
          [resArray[0]]: resArray[1] ? resArray[1] : "",
        };
      }, {});

      returnObject = {
        selectedType: paramObject[this.typeKey],
        selectedDb: parseInt(paramObject[this.dbKey], 10),
      };
    }

    return returnObject;
  }

  setStateFromUrl(selectedDb, selectedType) {
    this.setState((previousState) => ({
      ...previousState,
      dbLoaded: true,
      selectedDb,
      selectedType,
    }));
  }

  componentDidMount() {
    const fetchPath = getApiPath(this.props.locale, "Menu");

    fetch(fetchPath)
      .then((res) => res.json())
      .then((result) => {
        if (result.status === 200) {
          this.handleLoadingDatabases(result.data);
          // If there is a queryString in the url, we set the state from there
          if (window.location.search) {
            const selectedObject = this.getSelectedFromUrl(
              // Puts the spaces etc back and removes the leading ?
              decodeURIComponent(window.location.search).replace(/^\?/, "")
            );
            const { selectedDb, selectedType } = selectedObject;
            if (selectedDb !== null && selectedType) {
              this.setStateFromUrl(selectedDb, selectedType);
            }
          }
        }
      })
      .catch((error) => {
        console.error(
          "There was a problem connecting to the database from Home",
          error
        );
        this.resetState();
      });
  }

  resetState = () => {
    this.setState((previousState) => ({
      ...previousState,
      databases: [],
      selectedDb: 0,
      dbLoaded: true,
    }));
  };

  render() {
    if (this.state.dbLoaded) {
      return (
        <div class={style["main--page"]}>
          <div class={style["search-dropdown"]}>
            <select
              name="select-db"
              id="select-db"
              class={style["search-dropdown-select"]}
              value={this.state.selectedDb}
              onChange={this.handleSelectDb}
            >
              {this.state.databases.map((db, index) => (
                <option key={index} value={index}>
                  {db.label}
                </option>
              ))}
            </select>
          </div>
          {this.state.databases[this.state.selectedDb] && (
            <SearchTypes
              handleClick={this.handleButtonClick}
              types={this.state.databases[
                this.state.selectedDb
              ].searchTypes.map((type) => {
                return {
                  text: type.label,
                  id: type.id,
                  classes: ["button--search"],
                  selected: type.id === this.state.selectedType,
                };
              })}
            />
          )}
          {this.getDisplayList(this.state.selectedType) && (
            <div>
              <TitleList
                pageTitle={this.state.databases[this.state.selectedDb].label}
                subTitle={this.translateTypeIdToTypeString(
                  this.state.selectedType
                )}
                displayList={this.getDisplayList(this.state.selectedType)}
                displayType={this.getDisplayType(this.state.selectedType)}
                database={this.getDatabase(this.state.selectedDb)}
                filterByLetter={this.state.filterByLetter}
                locale={this.props.locale}
              />
            </div>
          )}
        </div>
      );
    }
  }
}
